import { Component } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { AsyncObservableComponent } from "@app/directives/_misc/async-observable/async-observable.component";
import { IAggregateFilterEvent } from "@app/directives/_resourceFilters/filter-bar/filter-bar.models";
import { SortDirection } from "@app/enum/SortDirection";
import { DateRange } from "@enums/DateRange.enum";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { tap } from "rxjs/operators";
import { EngineerJobItemType } from "../../foundation.enums";
import { IEngineerCommission } from "../../foundation.interfaces";
import { EngineerCommissionService } from "../../_services/engineer-commission.service";
import { VehicleValidationCheckRecordService } from "../../_services/vehicle-validation-check-record.service";
import './engineer-commission-history-list.component.scss';

@UntilDestroy()
@Component({
    selector: 'engineer-commission-history-list',
    template: require('./engineer-commission-history-list.component.html')

})
export class EngineerCommissionHistoryListComponent {

    tableColumns: IVTableColumn<IEngineerCommission>[] = [];
    tableRows: IVTableRow[] = [];

    commissions: IEngineerCommission[];
    loading: boolean;

    defaultDateRange: DateRange = DateRange.ThisMonth;
    startDate: Date;
    endDate: Date;

    constructor(
        private readonly engineerCommissionService: EngineerCommissionService,
        private readonly vehicleValidationCheckRecordService: VehicleValidationCheckRecordService,
        private readonly vTableService: VTableService) { }

    ngOnInit(): void {
        this.createTable();
    }

    onFilterChanged(filterEvent: IAggregateFilterEvent<IEngineerCommission>): void {
        if (filterEvent.trigger == "date") {
            this.startDate = filterEvent.date[0];
            this.endDate = filterEvent.date[1];
            this.getCommissions();
        }
    }

    //--

    private getCommissions(): void {
        this.engineerCommissionService.getEngineerCommissions({ Start: this.startDate.toISOString(), End: this.endDate.toISOString() }).pipe(untilDestroyed(this),
            tap(commissions => {
                    this.commissions = commissions;
                    this.tableRows = this.vTableService.createTableRows(this.commissions, this.tableColumns);
                })
            ).subscribe();
    }

    private createTable(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createDateTableHeader({ tKey: "EngineerHistory.CompletionDate", sorted: true, sortDirection: SortDirection.Descending }),
                createCellFunction: commission => this.vTableService.createDateCell(commission.Timestamp)
            },
            {
                header: this.vTableService.createTableHeader({ title: "ID", width: 100 }),
                createCellFunction: commission => this.vTableService.createTableCell(commission.Id)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "EngineerHistory.JobType" }),
                createCellFunction: commission => this.vTableService.createEnumCell(EngineerJobItemType, "EngineerJobItemType", commission.VisitReasonId)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "EngineerHistory.DeviceValidation", minTableWidth: 650 }),
                createCellFunction: commission => this.getValidationCheckForCommission(commission)
            }
        ]
    }

    private getValidationCheckForCommission(commission: IEngineerCommission): any {
        const validationObservable = this.vehicleValidationCheckRecordService.getRecordResultsForTable(commission);

        return this.vTableService.createTableCell(commission, {
            component: AsyncObservableComponent,
            componentInputs: {
                observable$: validationObservable,
                useLoading: true
            }
        })
    }

}
